var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1127,
    viewBox: "0 0 1512 1127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_63057)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.06 1015.86C1293.46 1019.86 1315.83 1020.52 1320.67 1019.28C1325.51 1018.04 1333.02 1013.91 1333.02 1013.91L1333.17 1017.91L1354.71 1017.97H1356V1015.7L1356.21 1004.34C1354.42 1002.03 1352.32 999.981 1349.97 998.239C1346.43 995.601 1342.42 993.66 1338.15 992.519C1334.22 991.394 1330.13 990.914 1326.05 991.099C1324.55 993.053 1322.88 994.868 1321.05 996.519C1307.76 1008.7 1290.46 1009.11 1290.46 1009.11C1289.72 1009.61 1289.05 1010.2 1288.46 1010.87C1287.07 1012.35 1285.93 1014.03 1285.06 1015.86Z",
    fill: "#050E30"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.86,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.06 1015.86C1293.46 1019.86 1315.83 1020.52 1320.67 1019.28C1325.51 1018.04 1333.02 1013.91 1333.02 1013.91L1333.17 1017.91L1354.71 1017.97L1355.99 1015.7L1356.2 1004.34C1354.41 1002.03 1352.31 999.981 1349.96 998.239L1338.14 992.519C1334.21 991.394 1330.12 990.914 1326.04 991.099C1324.54 993.053 1322.87 994.868 1321.04 996.519C1321.71 996.519 1337.28 996.849 1348.85 1005.74C1348.85 1005.74 1328.48 1013.24 1314.85 1014.74C1301.22 1016.24 1288.37 1010.84 1288.37 1010.84C1287.01 1012.33 1285.9 1014.02 1285.06 1015.86Z",
    fill: "url(#paint0_linear_1940_63057)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.27 896.499C1404.27 896.499 1379.75 921.079 1360.27 919.769C1340.79 918.459 1333 903.659 1333 903.659L1350 863.459L1367.21 862.819L1404.27 896.499Z",
    fill: "url(#paint1_radial_1940_63057)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.27 896.499C1404.27 896.499 1379.75 921.079 1360.27 919.769C1340.79 918.459 1333 903.659 1333 903.659L1350 863.459L1367.21 862.819L1404.27 896.499Z",
    fill: "#050E30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.15 993.37L1326.04 991.08C1340.55 990.37 1356.2 1004.32 1356.2 1004.32L1356.35 1008.32H1356.41C1356.93 1007.9 1360.34 1004.98 1359.97 1002.87C1359.58 1000.6 1357.66 994.4 1357.66 994.4C1360.66 980.07 1365.32 921.34 1363.75 915.89C1362.18 910.44 1357.4 901.6 1357.4 901.6C1356.34 897.96 1355.47 886.83 1355.47 886.83C1348.92 887.32 1332.21 910.95 1332.21 910.95C1332.65 914.68 1332.95 918.38 1333.14 922.03C1334.74 953.03 1327.97 981.29 1327.97 981.29C1325.7 981.99 1321.68 985.05 1321.68 985.05C1321.52 988.81 1324.15 993.37 1324.15 993.37Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.15 993.37L1326.04 991.08C1340.55 990.37 1356.2 1004.32 1356.2 1004.32L1356.35 1008.32H1356.41C1356.93 1007.9 1360.34 1004.98 1359.97 1002.87C1359.58 1000.6 1357.66 994.4 1357.66 994.4C1360.66 980.07 1365.32 921.34 1363.75 915.89C1362.18 910.44 1357.4 901.6 1357.4 901.6C1356.34 897.96 1355.47 886.83 1355.47 886.83C1348.92 887.32 1332.21 910.95 1332.21 910.95C1332.65 914.68 1332.95 918.38 1333.14 922.03C1341.93 925.31 1349.43 931.343 1354.51 939.23C1354.51 939.23 1357.38 967.13 1352.37 985.88C1352.37 985.88 1338.14 979.69 1327.97 981.29C1327.97 981.29 1345.62 980.63 1358.69 1002.78L1354.69 1000.68C1354.69 1000.68 1337.69 984.5 1321.69 985.05C1321.52 988.81 1324.15 993.37 1324.15 993.37Z",
    fill: "#774AA4"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.59 994.81L1382.59 988.54C1387.03 988.237 1391.48 988.973 1395.59 990.69C1401.93 993.51 1408.9 1000.19 1408.9 1000.19L1409.13 1006.3C1409.13 1006.3 1412.32 1006.12 1413.97 1004.88C1414.24 1004.71 1414.47 1004.48 1414.64 1004.21C1414.81 1003.94 1414.93 1003.64 1414.97 1003.32C1415.16 1000.76 1411.97 992.44 1411.7 991.85C1413.52 967.02 1414.4 916.85 1411.64 908.67C1409.92 903.647 1407.69 898.814 1404.98 894.25L1381.54 915.81C1382.22 918.362 1382.72 920.958 1383.03 923.58C1383.79 929.548 1384.13 935.564 1384.03 941.58C1383.84 958.51 1382.03 982.21 1382.03 982.21C1382.03 982.21 1377.67 982.47 1377.26 985.34C1377.2 985.704 1377.18 986.072 1377.2 986.44C1377.4 989.268 1377.86 992.07 1378.59 994.81Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1411.72 991.81C1413.54 966.98 1414.42 916.81 1411.66 908.63C1409.94 903.607 1407.71 898.774 1405 894.21L1381.54 915.81C1382.22 918.362 1382.72 920.958 1383.03 923.58V923.63C1383.03 923.63 1402.19 926.14 1406.83 931.28C1406.83 931.28 1411.08 969.72 1409.72 987.92C1409.72 987.92 1401.56 982.85 1394.25 982.04C1400.89 983.559 1406.95 986.95 1411.72 991.81Z",
    fill: "#774AA4"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.9 770.72C1266.9 770.72 1268.7 761.72 1264.74 754C1260.78 746.28 1248.94 743.35 1248.94 743.35C1248.94 743.35 1245.65 747.66 1247.48 751.67C1249.31 755.68 1256.73 766.21 1256.73 766.21C1256.73 766.21 1264 771.45 1266.9 770.72Z",
    fill: "#050E30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.76 755.45C1397.76 755.45 1394.76 750.61 1395.56 748.25C1396.36 745.89 1409.41 739.69 1418.76 744.25C1428.11 748.81 1429.35 757.96 1428.59 761.76C1427.83 765.56 1423.43 768.24 1423.43 768.24C1423.43 768.24 1413.52 767.67 1410.8 765.95C1408.08 764.23 1397.76 755.45 1397.76 755.45Z",
    fill: "#050E30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.82 748.9C1247.82 746.992 1248.2 745.105 1248.95 743.349C1253.19 746.327 1256.9 749.983 1259.95 754.169C1265.32 761.399 1266.95 770.719 1266.95 770.719C1263.31 769.856 1259.86 768.327 1256.78 766.21C1256.78 766.21 1258.53 769.209 1268.98 773.289L1269.87 770C1270.73 769.4 1298.46 750.25 1310.29 728C1311.4 720.391 1313.24 712.906 1315.78 705.65C1317.74 700.376 1320.16 695.289 1323.03 690.45C1323.71 689.33 1324.12 688.729 1324.12 688.729C1324.12 688.729 1325.94 661.229 1320.78 654.289C1318 650.655 1315.54 646.787 1313.42 642.729C1310.1 651.109 1307.42 659.731 1305.42 668.52C1301.73 684.16 1290.35 712.52 1290.35 712.52C1290.35 712.52 1286.98 711.119 1286.16 711.599C1285.82 711.819 1285.7 712.679 1285.67 713.599C1285.67 714.438 1285.71 715.276 1285.8 716.109C1285.8 716.109 1268.71 731.059 1260.8 736.109C1252.89 741.16 1247.64 741.789 1247.64 741.789C1247.64 741.789 1246.71 746.6 1247.82 748.9Z",
    fill: "#0E1B5E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1320.76 910.04C1331.89 918.79 1351.52 920.1 1351.52 920.1C1353.21 909.42 1357.81 891.91 1359.69 884.99L1360.5 882.04C1365.07 895.383 1371.8 907.884 1380.43 919.04C1391.11 917.04 1399.74 910.42 1405.61 904.47C1408.82 901.252 1411.69 897.714 1414.17 893.91C1412.22 891.245 1410.54 888.386 1409.17 885.38C1409.14 885.339 1409.11 885.291 1409.1 885.24C1408.36 883.577 1407.77 881.854 1407.32 880.09C1405.64 873.02 1399.86 811.45 1397.91 792.15C1395.96 772.85 1392.91 745.22 1393.91 729.07C1394.24 723.89 1395.45 712.69 1396.97 699.9C1400.15 672.83 1404.6 638.53 1404.6 638.53C1402.88 630.85 1398.15 629.59 1398.15 629.59C1385.9 629.43 1373.93 620.1 1373.93 620.1C1370.37 617.68 1342.06 618.86 1339.09 623.1C1336.12 627.34 1313.39 642.73 1313.39 642.73C1313.39 642.73 1318.14 649.49 1320.06 668.18C1320.8 675.45 1322.51 687 1324.41 700.29C1324.41 700.29 1324.41 700.58 1324.53 701.11C1324.57 701.308 1324.59 701.509 1324.61 701.71C1326.77 716.71 1329.12 733.79 1330.61 749.46C1330.61 749.72 1330.66 749.98 1330.68 750.24C1330.76 750.91 1330.81 751.57 1330.87 752.24C1330.87 752.58 1330.93 752.9 1330.96 753.24V753.39C1331.37 757.91 1331.68 762.27 1331.89 766.39C1331.97 768.09 1332.04 769.95 1332.08 771.95V772.5C1332.86 808.76 1327.71 887.79 1325.89 895.56C1324.72 900.56 1323 905.416 1320.76 910.04Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.41 700.299C1324.41 700.299 1324.41 700.589 1324.53 701.119C1324.57 701.318 1324.59 701.518 1324.61 701.719C1325.51 708.319 1329.32 736.489 1330.61 749.469C1330.61 749.729 1330.66 749.989 1330.68 750.249C1330.76 750.969 1330.82 751.629 1330.87 752.249C1330.87 752.609 1330.93 752.929 1330.96 753.249V753.399C1331.65 762.849 1331.96 770.009 1332.08 771.989V772.539L1341.08 757.599L1346.46 820.599C1346.46 820.599 1344.36 766.289 1343.39 755.599C1343.36 755.05 1343.29 754.502 1343.2 753.959C1342.36 750.119 1366.62 740.409 1382.63 736.869C1382.63 736.869 1380.73 786.109 1383.73 801.089C1386.73 815.739 1404.89 876.649 1409.07 885.289C1408.33 883.627 1407.74 881.904 1407.29 880.139C1405.61 873.069 1399.83 811.499 1397.88 792.199C1395.93 772.899 1392.88 745.269 1393.88 729.119C1394.21 723.939 1395.42 712.739 1396.94 699.949L1396.87 699.709L1393.16 688.609C1393.16 688.609 1390.16 691.219 1369.09 701.609C1350.14 710.909 1341.98 712.279 1340.5 712.469C1343.01 712.289 1363.37 710.719 1371.61 707.349C1371.61 707.349 1354.75 716.619 1340.45 718.079C1333.43 713.907 1327.84 707.709 1324.41 700.299Z",
    fill: "#774AA4"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.21 766.68C1244.21 766.68 1236.32 760.22 1230.93 759.12C1230.93 759.12 1223.75 757.36 1220.61 757.38C1217.47 757.4 1212.86 757.58 1210.37 757.06C1207.88 756.54 1198.75 749.39 1198.01 748.06C1197.27 746.73 1199.11 744.73 1200.17 744.54C1201.23 744.35 1204.92 746.73 1204.92 746.73C1204.92 746.73 1225.51 751.31 1232.53 752.89C1239.55 754.47 1245.7 761.57 1245.7 761.57L1245.78 763.7L1244.21 766.68Z",
    fill: "url(#paint2_linear_1940_63057)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.75 757.81C1391.75 757.81 1384.58 761.52 1383.75 764.22C1383.39 765.36 1387.87 768.05 1391.11 766.09C1394.35 764.13 1391.75 757.81 1391.75 757.81Z",
    fill: "url(#paint3_linear_1940_63057)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1353.72 586.879C1353.72 586.879 1355.86 600.409 1359.8 609.139C1359.8 609.139 1358.66 616.679 1355.01 621.399C1351.36 626.119 1346.74 625.079 1346.74 625.079C1346.74 625.079 1343.44 622.909 1342.6 620.949C1342.6 620.949 1342.49 613.949 1341.43 610.129L1352.29 585.409L1353.72 586.879Z",
    fill: "url(#paint4_linear_1940_63057)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.19 577.24C1303.64 579.52 1303.54 583.12 1303.6 587.24C1303.65 589.36 1303.72 591.62 1303.93 593.88C1303.93 594.34 1304.02 594.8 1304.08 595.25C1304.35 597.501 1304.84 599.721 1305.53 601.88C1308.53 610.74 1321.99 621.88 1331.31 620.29C1339.48 618.9 1346.97 608.02 1350.49 598.29C1350.62 597.94 1350.74 597.58 1350.85 597.23C1351.15 596.34 1351.41 595.47 1351.65 594.62L1351.74 594.24C1354.42 583.74 1354.74 566.24 1351.94 556.09C1349.67 547.93 1343.94 543.32 1335.07 540.96C1332.83 540.388 1330.57 539.951 1328.28 539.65C1324.17 539.064 1320 538.983 1315.87 539.41H1315.75C1311.52 539.8 1307.48 541.323 1304.05 543.82C1301.93 545.476 1300.25 547.628 1299.15 550.086C1298.06 552.545 1297.58 555.235 1297.77 557.92C1298.15 567.07 1302.19 572.39 1303.19 577.24Z",
    fill: "url(#paint5_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.19 577.249C1303.65 579.519 1303.54 583.109 1303.59 587.199C1308.05 591.019 1312.94 585.199 1312.94 585.199C1313 582.429 1311.46 574.079 1308.74 570.679C1307.28 568.732 1305.28 567.26 1302.99 566.449C1302.3 562.199 1305.25 556.449 1305.25 556.449C1315.33 557.449 1330 546.049 1330 546.049C1335.87 551.639 1333.74 561.509 1333.74 561.509C1327.04 558.849 1318.59 560.089 1318.59 560.089C1319.45 574.729 1324.24 584.499 1324.24 584.499C1337.3 584.699 1344.83 574.859 1344.83 574.859C1349.98 581.719 1350.12 598.359 1350.12 598.359L1350.47 598.269C1350.97 596.879 1351.38 595.519 1351.72 594.269C1354.4 583.769 1354.72 566.269 1351.92 556.129C1349.65 547.959 1343.92 543.349 1335.05 540.989L1315.85 539.449H1315.78L1304.08 543.839C1301.96 545.497 1300.28 547.649 1299.18 550.107C1298.09 552.566 1297.61 555.255 1297.8 557.939C1298.16 567.069 1302.18 572.389 1303.19 577.249Z",
    fill: "url(#paint6_linear_1940_63057)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.65 564.129C1298.07 561.983 1297.77 559.772 1297.75 557.549C1298.7 559.252 1300 560.74 1301.55 561.919C1301.55 561.919 1301.65 554.689 1306.06 549.979C1306.06 549.979 1309.98 550.439 1316.95 548.579C1323.92 546.719 1328.46 543.239 1330.65 542.779C1332.84 542.319 1340.41 546.869 1341.49 548.779C1342.57 550.689 1342.74 553.059 1341.24 556.019C1341.24 556.019 1341.8 560.089 1345.4 566.019C1346.87 568.537 1348.51 570.952 1350.3 573.249L1353.98 569.029C1353.98 569.029 1356.65 551.029 1355.21 547.029C1350.66 542.774 1344.93 539.986 1338.77 539.029C1328.47 537.429 1324.77 537.479 1316.84 537.089C1308.91 536.699 1294.19 532.899 1294.19 532.899C1294.19 532.899 1296.38 536.169 1298.31 537.019C1298.31 537.019 1291.7 541.849 1291.11 548.459C1291.09 548.832 1291.09 549.206 1291.11 549.579C1291.38 555.939 1298.12 563.569 1298.65 564.129Z",
    fill: "#050E30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1336.9 562.729C1331.15 560.15 1324.87 558.997 1318.58 559.369C1319.22 561.123 1320.4 562.631 1321.95 563.679C1321.95 563.679 1325.23 561.339 1336.9 562.729Z",
    fill: "#050E30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.75 570.669C1308.75 570.669 1302.41 561.869 1298.84 564.879C1298.84 564.879 1299.18 568.149 1300.46 569.729C1300.57 569.187 1300.86 568.696 1301.28 568.334C1301.7 567.973 1302.23 567.76 1302.78 567.729C1304.86 567.449 1308.75 570.669 1308.75 570.669Z",
    fill: "#050E30"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1304.09 595.22C1304.35 597.472 1304.83 599.693 1305.53 601.85C1308.53 610.7 1321.99 621.85 1331.31 620.26C1339.48 618.87 1346.98 607.98 1350.49 598.26C1350.94 597 1351.32 595.78 1351.64 594.58C1351.68 594.459 1351.72 594.336 1351.74 594.21C1349.37 590.83 1339.3 591.41 1339.3 591.41C1334.02 589.955 1328.63 588.952 1323.18 588.41C1317 587.99 1307.21 591.92 1304.09 595.22Z",
    fill: "#783E7A"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1253 747.229C1249.91 748.432 1246.71 749.304 1243.44 749.829C1238.77 750.459 1221.6 749.379 1217.07 748.219C1212.54 747.059 1204.76 743.679 1203.33 743.529C1201.9 743.379 1201.06 745.449 1201.73 747.059C1201.73 747.059 1206.81 752.169 1211.88 753.919C1211.88 753.919 1220.56 754.309 1228.74 755.019C1236.92 755.729 1244.95 763.019 1244.95 763.019C1243.57 765.626 1241.72 767.958 1239.5 769.899C1239.5 769.899 1234.5 770.129 1232.82 771.419C1231.14 772.709 1229.82 776.329 1229.69 780.419C1230.32 780.776 1231.03 780.949 1231.75 780.921C1232.47 780.893 1233.17 780.664 1233.77 780.259C1233.77 780.259 1239.01 774.259 1242.05 773.259C1245.09 772.259 1252.97 770.169 1255.22 767.739C1257.47 765.309 1257.22 757.159 1257.22 757.159L1260.22 754.679C1260.22 754.679 1256.25 748.439 1253 747.229Z",
    fill: "url(#paint7_linear_1940_63057)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.83 626.279C1337.19 620.149 1342.25 615.019 1342.25 615.019L1342.6 620.949C1342.6 621.859 1346.74 625.079 1346.74 625.079C1356.83 622.329 1359.8 609.139 1359.8 609.139L1358.7 606.439C1361.19 608.649 1366.09 613.899 1366.09 613.899C1368.14 615.809 1371.97 617.049 1374.74 618.719C1372.58 628.019 1369.27 637.015 1364.89 645.499C1357.66 659.439 1349.52 676.259 1344.38 688.689C1344.38 688.689 1330.52 666.169 1328.66 640.129L1335.83 626.279Z",
    fill: "#0E1B5E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1402.12 719.27C1402.71 726.79 1399.85 743.01 1399.85 743.01C1399.85 743.01 1395.65 742.55 1395.38 743.58C1395.28 745.138 1395.34 746.703 1395.55 748.25C1396.89 745.52 1411.11 744.25 1417.9 748.75C1424.69 753.25 1426.98 762.28 1426.36 764.75C1426.15 765.49 1425.79 766.179 1425.31 766.771C1424.82 767.364 1424.21 767.847 1423.52 768.19L1427.15 766.82L1427.94 765.32C1429.65 762.03 1433.53 754.01 1433.8 748.69C1434.03 744.4 1433.08 737.69 1431.68 731.69C1430.97 728.434 1430.03 725.236 1428.85 722.12C1426.16 715.2 1424.36 708.21 1419.78 692.05C1415.2 675.89 1404.62 638.59 1404.62 638.59C1404.62 638.59 1390.96 654.8 1390.2 667.28C1389.75 674.41 1391.55 682.69 1393.2 688.44L1393.26 688.62C1394.43 692.81 1395.49 695.62 1395.49 695.62C1395.49 695.62 1401.53 711.73 1402.12 719.27Z",
    fill: "#0E1B5E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.65 761.889L1425.77 759.889C1425.77 759.889 1421.67 745.769 1407.18 745.889C1407.18 745.889 1404.18 750.889 1400.72 751.779C1400.72 751.779 1409.19 750.169 1416.03 753.169C1417.98 753.97 1419.75 755.154 1421.23 756.652C1422.71 758.151 1423.87 759.932 1424.65 761.889Z",
    fill: "url(#paint8_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1257.11 761.11C1257.11 761.11 1251.92 752.41 1245.65 749.44C1245.65 749.44 1251.5 747.44 1252.65 746.25C1256.35 749.371 1259.51 753.089 1261.99 757.25L1257.11 761.11Z",
    fill: "#783E7A"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354 1019.19C1354 1019.19 1385.62 1019.44 1389 1017.88C1391.39 1016.72 1393.66 1015.34 1395.78 1013.75V1015.18L1409.42 1014.67C1409.9 1009.85 1409.72 1004.98 1408.88 1000.21C1397.28 984.529 1382.54 988.559 1382.54 988.559C1381.65 990.082 1380.68 991.551 1379.62 992.959C1373.58 1001.01 1365.43 1007.24 1356.07 1010.96C1355.28 1011.71 1354.63 1012.6 1354.15 1013.58C1353.73 1014.45 1353.5 1015.4 1353.47 1016.37C1353.45 1017.34 1353.63 1018.3 1354 1019.19Z",
    fill: "#050E30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.75 592.439C1323.53 592.879 1322.25 593.158 1320.96 593.269C1319.09 593.379 1313.13 593.599 1310.96 595.059C1311.82 596.128 1312.89 597 1314.12 597.614C1315.34 598.228 1316.68 598.571 1318.05 598.619C1319.01 598.587 1319.95 598.301 1320.77 597.789C1321.43 596.804 1322.37 596.048 1323.48 595.629C1324.18 594.701 1324.62 593.598 1324.75 592.439Z",
    fill: "url(#paint9_linear_1940_63057)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1323.45 595.63L1320.74 597.79C1320.74 597.79 1322.6 593.25 1323.45 595.63Z",
    fill: "#B85652"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.07 596.38C1333.51 595.647 1331.78 595.376 1330.07 595.6C1329.92 595.802 1329.83 596.045 1329.81 596.298C1329.8 596.55 1329.86 596.802 1329.99 597.02L1331.76 596.75C1331.39 598.105 1330.73 599.365 1329.82 600.441C1328.92 601.518 1327.79 602.387 1326.52 602.99C1322.09 605.2 1316.64 604.56 1316.64 604.56C1316.64 604.56 1323.39 606.07 1327.33 603.47C1329.76 601.803 1331.7 599.513 1332.95 596.84C1333.6 596.502 1334.34 596.344 1335.07 596.38Z",
    fill: "url(#paint10_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.71,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1353.09 585.069L1355.25 594.579C1355.25 594.579 1355.35 611.349 1342.71 619.579L1342.04 613.049C1342.04 613.049 1352.86 600.509 1353.09 585.069Z",
    fill: "url(#paint11_linear_1940_63057)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1367.24 614.81L1370.33 617.48C1370.33 617.48 1364.49 641.87 1357.17 654.38C1357.17 654.38 1339.29 654.59 1332.31 647.97C1332.31 647.97 1334.84 668.15 1339.11 676.97C1333.79 665.321 1330.32 652.911 1328.83 640.19L1338.4 620.47L1346.15 625.31L1352.31 622.31L1367.24 614.81Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.31 537.18C1298.83 537.26 1299.4 537.33 1300 537.39C1299.44 537.279 1298.88 537.209 1298.31 537.18Z",
    fill: "url(#paint12_linear_1940_63057)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.65 564.13C1298.07 561.984 1297.77 559.772 1297.75 557.55C1296.2 555.631 1295.33 553.255 1295.26 550.79C1295.26 550.79 1299.85 542.5 1313.46 540.97C1313.46 540.97 1320.87 538.86 1327.02 541.9C1327.02 541.9 1313.72 548.5 1304.26 548.9C1304.26 548.9 1299.53 553.37 1301.55 561.96C1301.55 561.96 1301.65 554.73 1306.06 550.02C1306.06 550.02 1309.98 550.48 1316.95 548.62C1323.92 546.76 1328.46 543.28 1330.65 542.82C1332.84 542.36 1340.41 546.91 1341.49 548.82C1342.57 550.73 1342.74 553.1 1341.24 556.06C1341.24 556.06 1341.8 560.13 1345.4 566.06C1346.87 568.577 1348.51 570.992 1350.3 573.29L1353.98 569.07C1353.98 569.07 1356.65 551.07 1355.21 547.07C1355.21 547.07 1350.86 548.48 1342.37 545.13C1333.88 541.78 1328.29 539.54 1328.29 539.54C1328.29 539.54 1309.6 538.48 1300.08 537.34C1303.4 538.041 1306.62 539.178 1309.64 540.72C1309.64 540.72 1292.64 545.1 1291.08 549.67C1291.38 555.94 1298.12 563.57 1298.65 564.13Z",
    fill: "#050E30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.45 572.81C1350.45 572.81 1352.92 565.58 1359.66 563.08C1359.66 563.08 1363.44 563.24 1366.28 568.44C1366.88 572.811 1366.46 577.262 1365.04 581.44C1362.66 588.84 1357.61 590.05 1355.77 590.01C1353.93 589.97 1351.65 588.94 1351.09 587.54C1350.53 586.14 1350.45 572.81 1350.45 572.81Z",
    fill: "url(#paint13_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365.45 571.809C1365.45 571.809 1362.8 568.079 1360.65 567.809C1358.5 567.539 1353.65 574.609 1352.21 579.429C1352.21 579.429 1358.63 571.099 1360.12 569.969C1361.61 568.839 1365.45 571.809 1365.45 571.809Z",
    fill: "#783E7A"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1357.94 571.119C1357.94 571.119 1359.76 572.519 1359.94 577.269C1360.12 582.019 1355.61 585.269 1355.61 585.269C1356.72 583.431 1357.38 581.359 1357.55 579.219C1357.56 578.325 1357.35 577.441 1356.94 576.645C1356.54 575.849 1355.94 575.164 1355.21 574.649L1357.94 571.119Z",
    fill: "#783E7A"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1368.21 615.81L1373.76 615.6C1373.76 615.6 1383.39 622.18 1387.43 632.23C1387.43 632.23 1376.11 634.69 1372.57 638.29C1372.57 638.29 1374.1 651.9 1373.57 659.29C1373.04 666.68 1342.38 703.29 1340.18 709.69C1340.18 709.69 1342.09 695.55 1344.36 687.92C1344.36 687.92 1360.28 653.06 1365.54 640.83C1368.63 633.708 1371.15 626.351 1373.07 618.83L1368.21 615.81Z",
    fill: "#1F307A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.71 623.239C1328.8 629.874 1322.88 637.477 1318.15 645.809L1324.15 652.519C1324.15 652.519 1319.96 663.339 1320.72 671.609C1320.72 671.609 1331.6 688.609 1342.72 694.369L1344.31 687.859C1344.31 687.859 1337.62 675.209 1335.11 667.709C1329.48 650.849 1328.62 640.109 1328.62 640.109L1335.03 628.039L1335.71 623.239Z",
    fill: "#1F307A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1346.74 625.08L1349.74 623.84C1349.74 623.84 1357.2 632.02 1357.62 643.02C1357.62 643.02 1369.52 628.81 1366.7 613.21C1366.7 613.21 1360.7 602.73 1359.51 602.37C1358.72 602.134 1357.92 601.957 1357.11 601.84L1357.8 604.37C1357.8 604.37 1358.63 611.58 1351.01 621.04C1351.05 621.04 1349 621.42 1346.74 625.08Z",
    fill: "#050E30"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1346.74 625.08L1341.93 623.419C1341.93 623.419 1334.1 632.08 1332.15 639.799C1332.86 634.454 1334.07 629.186 1335.74 624.06C1337.02 620.295 1339.23 616.914 1342.16 614.229C1342.16 614.229 1343 619.23 1342.6 620.95C1343.84 622.459 1345.23 623.842 1346.74 625.08Z",
    fill: "#050E30"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1402.12 719.27C1402.71 726.79 1399.85 743.01 1399.85 743.01C1405.79 741.46 1416.91 744.63 1422.85 750.91C1426.25 754.46 1427.48 760.63 1427.92 765.31C1429.63 762.02 1433.51 754 1433.78 748.68C1434.01 744.39 1433.06 737.68 1431.66 731.68C1432.48 744.39 1426.17 751.97 1426.17 751.97C1417 741.23 1401.66 739.81 1401.66 739.81L1405.16 724.23C1407.05 720.33 1412.38 719.42 1412.38 719.42C1411.99 718.02 1404.15 712.29 1404.15 712.29C1400.3 707.44 1394.02 690.84 1393.15 688.58C1394.32 692.77 1395.38 695.58 1395.38 695.58C1395.38 695.58 1401.53 711.73 1402.12 719.27Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1360.53 876.63C1357.72 863.09 1350.26 834.63 1349.79 832.89L1359.69 884.99L1360.5 882.04C1365.07 895.383 1371.8 907.883 1380.43 919.04C1391.11 917.04 1399.74 910.42 1405.61 904.47C1397.83 909.3 1388.21 913.65 1380.29 912.31C1380.29 912.29 1363.43 890.6 1360.53 876.63Z",
    fill: "url(#paint14_linear_1940_63057)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1419.67 752.349C1421.78 754.493 1423.37 757.084 1424.34 759.929C1424.73 761.008 1424.81 762.171 1424.58 763.294C1424.35 764.417 1423.82 765.456 1423.05 766.299L1418.37 766.469C1416.9 768.245 1416.08 770.472 1416.05 772.779L1417.86 774.859C1417.86 774.859 1412.49 775.769 1409.72 775.159V776.279C1407.43 776.452 1405.12 776.298 1402.87 775.82C1400.81 775.881 1398.74 775.687 1396.73 775.239C1396.19 774.499 1395.85 773.636 1395.73 772.729C1394.28 772.738 1392.85 772.452 1391.52 771.89C1390.6 765.488 1391.05 758.965 1392.84 752.75C1392.84 752.75 1393.44 752.42 1397.22 752.58C1397.22 752.58 1399.02 751.58 1403.3 751.58C1403.33 751.54 1413.3 750.959 1419.67 752.349Z",
    fill: "url(#paint15_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1344.35 687.879C1344.35 687.879 1341.42 704.879 1340.17 709.649C1338.92 714.419 1343.23 753.889 1343.23 753.889C1343.23 753.889 1347.32 814.109 1347.65 820.819L1360.5 882.039C1360.5 882.039 1346.86 833.799 1345.27 818.569C1343.68 803.339 1343.27 754.909 1343.27 754.909C1343.27 754.909 1337.21 718.139 1337.96 710.759C1338.71 703.379 1338.96 676.909 1338.96 676.909L1344.35 687.879Z",
    fill: "url(#paint16_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.74 746.119C1257.39 746.749 1267.8 756.979 1269.82 769.999C1270.68 769.399 1298.41 750.249 1310.24 727.999C1311.35 720.39 1313.19 712.906 1315.73 705.649C1317.69 700.376 1320.11 695.289 1322.98 690.449L1321.3 678.449C1321.3 678.449 1313.04 706.159 1309.54 714.539C1309.54 714.539 1296.03 712.009 1290.29 712.539C1290.29 712.539 1301.06 717.029 1304.5 723.169C1304.5 723.169 1293.76 715.169 1285.61 713.619L1285.74 716.129C1285.74 716.129 1294.52 717.869 1301.13 727.129C1301.13 727.129 1282.84 759.129 1272.41 764.609C1272.43 764.599 1264.61 750.609 1256.74 746.119Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.59 994.81L1382.59 988.54C1387.03 988.237 1391.48 988.973 1395.59 990.69C1401.93 993.51 1408.9 1000.19 1408.9 1000.19L1409.13 1006.3C1409.13 1006.3 1412.32 1006.12 1413.97 1004.88L1413.45 1003.07C1412.49 1000.11 1410.94 997.382 1408.89 995.041C1406.85 992.7 1404.35 990.798 1401.55 989.45C1391.79 984.51 1379.55 984.32 1377.19 986.45C1377.39 989.275 1377.86 992.074 1378.59 994.81Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.86,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354 1019.19C1354 1019.19 1385.62 1019.44 1389 1017.88C1391.39 1016.72 1393.66 1015.34 1395.78 1013.75V1015.18L1409.42 1014.67C1409.9 1009.85 1409.72 1004.98 1408.88 1000.21C1397.28 984.529 1382.54 988.559 1382.54 988.559C1381.65 990.082 1380.68 991.551 1379.62 992.959V993.039C1379.62 993.039 1391.68 993.909 1402.08 1004.74C1396.69 1009.65 1390.16 1013.12 1383.08 1014.84C1371.21 1017.73 1354.15 1013.59 1354.15 1013.59C1353.73 1014.46 1353.5 1015.41 1353.48 1016.37C1353.45 1017.34 1353.63 1018.3 1354 1019.19Z",
    fill: "url(#paint17_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1433.83 746.98C1431.99 737.823 1429.34 728.848 1425.91 720.16C1419.91 704.57 1411.19 677.26 1408.37 663.54C1405.55 649.82 1401.18 637.28 1399.19 634.95C1397.2 632.62 1388.98 631.25 1385.81 628.86C1385.81 628.86 1375.73 619.41 1373.81 617.98L1370.98 618.08L1368.2 615.77L1367.03 614.77C1367.03 614.77 1360.78 606.03 1359.63 605.47C1359.08 605.156 1358.46 604.988 1357.83 604.98C1357.83 604.98 1353.02 595.09 1352.74 589.2C1352.74 589.2 1360.36 588.4 1362.98 581C1365.6 573.6 1362.77 567.2 1360.58 564.88C1360.58 564.88 1354.82 565.62 1352.3 569.15C1352.3 569.15 1354.05 550.38 1352.95 547.41C1351.85 544.44 1337.5 538.83 1332.86 538.34C1332.86 538.34 1346.32 538.8 1355.17 547.12C1355.17 547.12 1356.17 554.12 1354.17 566.77C1355.6 565.036 1357.49 563.749 1359.63 563.06C1359.63 563.06 1363.99 563.34 1366.25 568.42C1366.25 568.42 1366.84 576.66 1364.76 582.85C1364.22 584.593 1363.22 586.159 1361.87 587.389C1360.52 588.619 1358.87 589.468 1357.08 589.85L1354.21 589.72L1357.53 601.78C1357.53 601.78 1358.32 601.05 1359.53 602.32C1360.74 603.59 1366.72 613.16 1366.72 613.16L1369.41 615.7L1373.31 615.56C1373.31 615.56 1378.82 617.56 1384.03 625.98C1386.22 627.093 1388.53 627.933 1390.92 628.48C1393.3 628.939 1395.71 629.273 1398.13 629.48C1400.06 630.42 1401.69 631.895 1402.81 633.73C1404.65 636.73 1415.52 677.01 1417.63 684.44C1419.74 691.87 1429.63 725 1431.63 731.55C1433.08 736.564 1433.82 741.759 1433.83 746.98Z",
    fill: "#783E7A"
  })))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1410.74 775.31C1409.58 770.648 1409.54 765.78 1410.62 761.1C1410.62 761.1 1407.45 768.8 1409.76 776.28L1410.74 775.31Z",
    fill: "url(#paint18_linear_1940_63057)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1402.91 775.81C1402.91 775.81 1401.54 773.48 1401.84 766.26C1402.13 759.4 1402.92 757.77 1402.92 757.77C1402.92 757.77 1401.27 760.61 1400.92 766.87C1400.57 773.13 1402.04 775.87 1402.04 775.87L1402.91 775.81Z",
    fill: "url(#paint19_linear_1940_63057)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1395.76 772.73C1395.08 767.579 1395.08 762.361 1395.76 757.21C1395.76 757.21 1393.56 766.36 1394.33 772.64C1394.8 772.717 1395.28 772.747 1395.76 772.73Z",
    fill: "url(#paint20_linear_1940_63057)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.93 593.81C1303.93 594.27 1304.02 594.73 1304.08 595.18C1304.3 596.887 1304.63 598.577 1305.08 600.24C1305.21 600.77 1305.38 601.3 1305.54 601.81C1305.95 602.984 1306.47 604.114 1307.11 605.18C1310.69 610.969 1315.86 615.609 1322 618.55C1323.68 619.341 1325.47 619.9 1327.3 620.21C1328.62 620.434 1329.98 620.434 1331.3 620.21C1336.47 619.32 1341.39 614.64 1345.18 608.83C1347.34 605.508 1349.12 601.948 1350.47 598.22C1350.6 597.87 1350.72 597.53 1350.84 597.22C1349.42 594.957 1347.79 592.835 1345.97 590.88C1343.07 587.61 1340.14 584.75 1340.14 584.75C1340.14 584.75 1324.55 588.05 1323.41 587.92C1322.2 587.565 1321.03 587.103 1319.91 586.54L1319.6 586.42C1318.82 586.034 1317.99 585.768 1317.13 585.63C1315.73 585.63 1312.06 587.34 1312.06 587.34C1311.04 589.222 1309.74 590.936 1308.2 592.42C1307 593.403 1305.48 593.899 1303.93 593.81Z",
    fill: "url(#paint21_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.1 585.59L1317.34 592.12L1324.74 592.47L1342.54 587.71L1326.07 590.01L1323.44 587.9C1321.37 587.009 1319.26 586.238 1317.1 585.59Z",
    fill: "url(#paint22_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1336.12 609.35L1347.66 600.48C1344.98 606.78 1333.8 616.72 1333.8 616.72L1331.02 618.72L1327.34 620.23C1328.66 620.453 1330.02 620.453 1331.34 620.23C1339.51 618.84 1347 607.96 1350.52 598.23C1350.65 597.88 1350.77 597.54 1350.89 597.23C1349.47 594.967 1347.84 592.844 1346.02 590.89L1345.13 590.43L1332.32 594.95L1317.47 594.35L1327.17 597.99L1338.85 595.63L1340.66 596.05L1333.48 607.52L1326.23 613.36L1336.12 609.35Z",
    fill: "url(#paint23_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.07 600.27C1305.2 600.8 1305.37 601.33 1305.53 601.84C1305.94 603.014 1306.46 604.143 1307.1 605.21L1307.35 602L1310.2 595.14L1305.07 600.27Z",
    fill: "url(#paint24_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1322 618.55C1323.68 619.341 1325.47 619.9 1327.3 620.21C1328.62 620.434 1329.98 620.434 1331.3 620.21C1336.47 619.32 1341.39 614.64 1345.18 608.83C1343.1 610.58 1334.73 617.48 1331.01 618.66C1329.28 619.26 1325.52 618.98 1322 618.55Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.34 595.06L1314.41 601.73L1314.62 612.93L1312.34 595.06Z",
    fill: "url(#paint25_linear_1940_63057)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1341 585.56L1350.45 572.81L1351.36 570.72C1346.98 574.831 1343.2 579.545 1340.15 584.72L1341 585.56Z",
    fill: "url(#paint26_radial_1940_63057)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.61 596.77L1355.24 590.01L1356.77 589.96L1349.97 599.3L1350.61 596.77Z",
    fill: "url(#paint27_radial_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.62,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.4 598.27C1337.4 598.27 1333.03 605.339 1331.4 606.909C1329.77 608.479 1319.06 613.319 1318.6 613.279C1318.14 613.239 1315.36 612.9 1315.36 612.9C1316.61 612.729 1317.85 612.469 1319.06 612.12C1320.48 611.65 1330.06 605.88 1330.53 604.96C1331 604.04 1337.4 598.27 1337.4 598.27Z",
    fill: "url(#paint28_linear_1940_63057)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.16 569.609L1324.19 572.389L1329.45 576.949L1337.25 571.899L1337.16 569.609Z",
    fill: "url(#paint29_linear_1940_63057)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.47 578.599L1307.01 581.12L1310.25 577.02L1303.42 577.28L1303.47 578.599Z",
    fill: "url(#paint30_linear_1940_63057)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1221 807.844V1033.81L1283 1039.81V807.844H1221Z",
    fill: "url(#paint31_linear_1940_63057)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1221 807.844V1033.81L1283 1039.81V807.844H1221Z",
    stroke: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1277 815.844L1283 1039.81L1343 1035.81V815.844H1277Z",
    fill: "url(#paint32_linear_1940_63057)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1277 815.844L1283 1039.81L1343 1035.81V815.844H1277Z",
    stroke: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1285 787.813C1283.23 786.893 1155 776.813 1155 776.813L1237 796.813L1430 815.813C1430 815.813 1290.14 790.493 1285 787.813Z",
    fill: "#0D2350"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1285 787.813C1283.23 786.893 1155 776.813 1155 776.813L1237 796.813L1430 815.813C1430 815.813 1290.14 790.493 1285 787.813Z",
    stroke: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1252 788.813C1247.58 788.813 1244 789.263 1244 789.813C1244 790.363 1247.58 790.813 1252 790.813C1256.42 790.813 1260 790.363 1260 789.813C1260 789.263 1256.42 788.813 1252 788.813Z",
    fill: "#0D2350"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1252 788.813C1247.58 788.813 1244 789.263 1244 789.813C1244 790.363 1247.58 790.813 1252 790.813C1256.42 790.813 1260 790.363 1260 789.813C1260 789.263 1256.42 788.813 1252 788.813Z",
    stroke: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1275 788.813C1270.58 788.813 1267 789.263 1267 789.813C1267 790.363 1270.58 790.813 1275 790.813C1279.42 790.813 1283 790.363 1283 789.813C1283 789.263 1279.42 788.813 1275 788.813Z",
    fill: "#0D2350"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1275 788.813C1270.58 788.813 1267 789.263 1267 789.813C1267 790.363 1270.58 790.813 1275 790.813C1279.42 790.813 1283 790.363 1283 789.813C1283 789.263 1279.42 788.813 1275 788.813Z",
    stroke: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1294 793.813C1289.58 793.813 1286 794.263 1286 794.813C1286 795.363 1289.58 795.813 1294 795.813C1298.42 795.813 1302 795.363 1302 794.813C1302 794.263 1298.42 793.813 1294 793.813Z",
    fill: "#0D2350"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1294 793.813C1289.58 793.813 1286 794.263 1286 794.813C1286 795.363 1289.58 795.813 1294 795.813C1298.42 795.813 1302 795.363 1302 794.813C1302 794.263 1298.42 793.813 1294 793.813Z",
    stroke: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1430 814.814L1238 792.814C1238 792.814 1155 772.534 1155 776.814C1155 777.594 1153 793.814 1153 793.814L1238 813.814L1431 834.814L1430 814.814Z",
    fill: "url(#paint33_linear_1940_63057)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1430 814.814L1238 792.814C1238 792.814 1155 772.534 1155 776.814C1155 777.594 1153 793.814 1153 793.814L1238 813.814L1431 834.814L1430 814.814Z",
    stroke: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.197 1049.58C191.197 1050.71 199.197 1062.02 199.197 1062.02L202.937 1058.43C216.657 1058.22 229.257 1065.66 229.257 1065.66L232.137 1072.83C232.137 1072.83 238.137 1066.14 238.947 1064.17L239.017 1063.87C238.877 1062.59 235.407 1060.13 235.407 1060.13C235.407 1060.13 240.947 1044.13 241.217 1041.54C241.487 1038.95 236.047 1034.42 236.047 1034.42C235.047 1023.34 244.297 994.011 244.827 989.541C245.357 985.071 247.907 956.881 249.027 954.151L249.147 953.81L249.287 953.411L249.527 952.76L250.307 950.451L250.487 949.901L250.777 949.031C251.777 946.081 253.017 942.161 254.327 938.031C257.137 929.221 257.327 925.421 258.087 922.031C259.087 917.221 261.747 889.901 263.477 872.681L263.557 871.841L263.707 870.281C263.707 869.741 263.807 869.221 263.857 868.731L264.047 866.731L264.367 863.461L266.717 862.871C266.717 862.871 279.837 939.63 279.337 942.38C278.837 945.13 272.687 967.111 272.687 967.111C270.517 990.231 278.317 1040.32 278.317 1040.32C278.317 1040.32 273.417 1051.49 273.387 1053.09V1053.26C273.877 1055.07 281.827 1061.12 281.827 1061.12L281.617 1071.52L285.507 1073.94L285.557 1071.5C285.557 1071.5 291.147 1062.9 298.027 1058.58C304.907 1054.26 317.537 1047.17 317.537 1047.17L317.887 1048.17L319.887 1045.51L315.057 1038.24C315.057 1038.24 320.607 1032.46 320.127 1031.65C319.647 1030.84 314.957 1026.92 314.957 1026.92C311.297 1003.43 313.797 956.341 313.797 956.341L314.797 946.901C314.097 903.221 307.797 842.491 307.797 842.491L309.367 839.63L308.447 836.75C274.547 841.11 223.977 815.021 223.977 815.021L217.307 836.411L219.987 845.221C222.167 880.011 215.227 946.81 215.227 946.81L212.467 949.63L213.587 957.141L204.777 975.141C202.097 992.991 199.337 1035 198.837 1042.78C198.787 1043.59 198.767 1044.03 198.767 1044.03C198.767 1044.03 191.217 1048.47 191.197 1049.58Z",
    fill: "#1F307A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.878 1074.74L371.218 1077.34L366.828 1074.11L365.448 1073.11C365.448 1073.11 337.778 1061.39 332.068 1058.03C327.743 1055.46 323.654 1052.51 319.848 1049.22L318.598 1048.12C317.938 1047.52 317.598 1047.12 317.598 1047.12H317.548C316.698 1047.44 304.918 1051.81 298.878 1056.3C292.628 1060.95 285.618 1071.44 285.618 1071.44L284.878 1074.74Z",
    fill: "#050E30"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.877 1074.74L284.737 1081.75L373.307 1083.54L371.217 1077.34L284.877 1074.74Z",
    fill: "#0E1B5E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.878 1082.69C197.148 1083.04 200.638 1083.28 204.158 1083.47C214.158 1083.98 224.438 1083.9 230.768 1083.76C233.688 1083.68 235.768 1083.62 236.658 1083.57H237.088L236.228 1078.87C233.415 1074.76 231.089 1070.33 229.298 1065.68C212.068 1055.68 202.978 1058.45 202.978 1058.45L199.238 1062.04C194.648 1070.28 193.878 1082.69 193.878 1082.69Z",
    fill: "#050E30"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.997 1089.35C193.667 1089.48 194.357 1089.62 195.077 1089.72C207.297 1091.72 223.957 1091.09 232.077 1090.6C235.077 1090.41 236.947 1090.24 236.947 1090.24L237.077 1083.57H236.647H230.717C226.547 1083.57 222.447 1083.5 218.557 1083.44C204.757 1083.2 193.867 1082.67 193.867 1082.67L192.997 1089.35Z",
    fill: "#0E1B5E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.197 1049.58C191.197 1050.71 199.197 1062.02 199.197 1062.02L202.937 1058.43C216.657 1058.22 229.257 1065.66 229.257 1065.66L232.137 1072.83C232.137 1072.83 238.137 1066.14 238.947 1064.17L239.017 1063.87L213.797 1052.25C221.181 1054.35 228.403 1056.98 235.407 1060.13C235.407 1060.13 240.947 1044.13 241.217 1041.54L219.217 1026.86C214.622 1015.17 211.791 1002.87 210.817 990.351C213.667 1006.98 226.817 1028.07 226.817 1028.07L236.027 1034.42C235.027 1023.34 244.277 994.011 244.807 989.541C245.337 985.071 247.887 956.881 249.007 954.151L249.127 953.811L249.267 953.411L249.507 952.761L250.287 950.451L250.467 949.901L250.757 949.031L234.957 956.841L220.167 945.841L218.527 918.261L225.157 941.341L222.837 886.901L231.087 860.381L250.087 853.751L259.237 863.071L256.757 913.171L254.237 938.171L254.307 937.991C257.117 929.181 257.307 925.381 258.067 921.991C259.067 917.181 261.727 889.861 263.457 872.641L263.537 871.801L263.687 870.241L263.837 868.691L264.027 866.691L264.347 863.421L266.697 862.831C266.697 862.831 279.817 939.591 279.317 942.341C278.817 945.091 272.667 967.071 272.667 967.071C270.497 990.191 278.297 1040.28 278.297 1040.28L298.687 1020.5L292.317 1035.9L273.367 1053.05V1053.22C273.857 1055.03 281.807 1061.08 281.807 1061.08L281.597 1071.48L285.487 1073.9L285.537 1071.46C285.537 1071.46 291.127 1062.86 298.007 1058.54C304.887 1054.22 317.517 1047.13 317.517 1047.13L317.867 1048.13L319.867 1045.47L299.867 1051.12L315.057 1038.2C315.057 1038.2 320.607 1032.42 320.127 1031.61L286.737 1050.9L305.737 1035.14L314.987 1026.93C311.327 1003.44 313.827 956.351 313.827 956.351L314.827 946.911L313.217 948.461L301.037 942.901L289.277 851.391L296.137 848.991L307.827 842.481L309.397 839.621L308.477 836.741C274.577 841.101 224.007 815.011 224.007 815.011L217.337 836.401L220.017 845.211C222.197 880.001 215.257 946.801 215.257 946.801L212.497 949.621L213.617 957.131L204.807 975.131C202.127 992.981 199.367 1034.99 198.867 1042.77C212.007 1042.21 220.557 1045.2 220.557 1045.2C209.077 1045.26 191.197 1049.58 191.197 1049.58Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.737 862.84L284.337 848.74L278.967 856.92L284.507 895.59L284.727 914.49L281.927 886.84L273.787 881.95L279.357 942.35L266.737 862.84Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.337 1040.29C278.337 1040.29 273.437 1051.46 273.407 1053.06V1053.23C273.897 1055.04 281.847 1061.09 281.847 1061.09L281.637 1071.49L285.527 1073.91L285.577 1071.47C285.577 1071.47 291.167 1062.87 298.047 1058.55C304.927 1054.23 317.557 1047.14 317.557 1047.14L317.907 1048.14L319.907 1045.48L315.077 1038.21C315.077 1038.21 320.627 1032.43 320.147 1031.62L286.737 1050.9L314.997 1026.9C311.337 1003.41 313.837 956.32 313.837 956.32L314.837 946.88L313.227 948.43L301.037 942.9L285.977 905.9L278.977 856.9L266.747 862.83C266.747 862.83 279.867 939.59 279.367 942.34C278.867 945.09 272.717 967.07 272.717 967.07C270.537 990.2 278.337 1040.29 278.337 1040.29Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.957 987.561L232.397 1013.9L228.397 1029.05L236.047 1034.32C236.047 1034.32 235.947 1023.92 238.457 1015.41C240.967 1006.9 244.947 989.961 244.957 987.561Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.197 1049.58L199.197 1062.02L202.937 1058.43C202.937 1058.43 213.987 1056.11 229.257 1065.66L232.137 1072.83C234.808 1070.14 237.121 1067.11 239.017 1063.83L213.797 1052.21L220.537 1045.21C220.537 1045.21 197.787 1046.84 191.197 1049.58Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.828 842.47L296.138 848.98L282.668 850.08L284.818 846.06L272.038 849.86L235.208 825.01L221.758 838.54L230.998 823.27L223.458 816.77L224.018 815L308.478 836.73L309.398 839.61L307.828 842.47Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.797 948.96L245.647 954.84L229.647 971.71C229.647 971.71 233.647 957.79 235.067 956.76C236.487 955.73 250.797 948.96 250.797 948.96Z",
    fill: "#774AA4"
  })))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.037 747.83C181.037 747.83 185.257 753.99 191.217 761.35C191.219 761.365 191.224 761.379 191.233 761.391C191.242 761.403 191.254 761.413 191.267 761.42C195.747 767.075 200.637 772.392 205.897 777.33C206.397 777.79 206.897 778.24 207.387 778.67C218.977 788.97 226.937 793.38 226.937 793.38L231.937 776.75L229.867 744L229.507 738.44L181.037 747.83Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.218 761.351L191.298 761.431L207.418 778.681C219.008 788.981 226.968 793.391 226.968 793.391L231.968 776.761L229.898 744.011L228.738 742.511L222.028 747.381L223.188 753.311L200.268 759.221L215.158 758.401L199.018 766.531L191.278 761.361L191.218 761.351Z",
    fill: "#774AA4"
  })))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.918 740.6C384.918 740.6 384.648 752.43 380.978 758.9C380.978 758.9 368.098 745.01 378.058 728.04L384.918 740.6Z",
    fill: "#050E30"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M425.998 712.64C425.998 712.64 427.478 710.97 422.858 718.64L414.528 720.56L408.648 728.64C408.648 728.64 405.588 732.53 401.528 732.29C397.468 732.05 393.878 728.29 393.878 728.29C393.878 728.29 405.318 706.53 409.178 704.53C413.038 702.53 425.998 712.64 425.998 712.64Z",
    fill: "url(#paint34_linear_1940_63057)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M376.647 750.51C378.718 746.39 381.767 742.84 385.527 740.17C393.717 740.98 402.657 739.96 403.477 739.1C404.387 738.1 410.237 728.19 413.707 724.59C417.937 720.22 424.347 718.7 424.347 718.7L424.647 715.9C419.147 712.61 412.887 714.26 411.027 715.5C409.167 716.74 404.877 726.01 404.877 726.01C403.087 728.13 399.637 727.18 399.637 727.18C399.637 727.18 401.187 718.7 403.947 713.56C405.583 710.488 407.766 707.74 410.387 705.45C411.077 705.36 415.497 707.45 415.497 707.45C419.967 712.58 428.137 712.92 428.137 712.92C428.857 712.58 429.491 712.08 429.988 711.458C430.486 710.836 430.834 710.108 431.007 709.33C420.917 707.2 412.317 695.24 412.317 695.24C412.317 695.24 409.317 693.02 407.967 693.8C406.617 694.58 399.197 705.57 391.967 714.12C384.737 722.67 371.307 734.12 371.307 734.12C370.307 747.74 376.647 750.51 376.647 750.51Z",
    fill: "url(#paint35_linear_1940_63057)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.907 747.12C318.907 747.12 319.277 750.24 320.247 754.82C321.449 760.674 323.18 766.407 325.417 771.95C330.347 783.79 335.417 790.37 336.197 790.6C336.977 790.83 350.317 786.21 356.247 781.34C362.177 776.47 371.317 764.03 371.317 764.03L381.937 763.03C385.867 754.26 384.937 740.58 384.937 740.58L384.217 741.12C384.336 747.203 383.235 753.249 380.977 758.9C373.217 749.04 377.167 728.84 377.167 728.84L378.057 728.04L376.577 727.15L376.097 727.58L375.807 727.82C374.207 729.24 370.457 732.46 367.467 734.82C366.338 735.741 365.122 736.552 363.837 737.24C362.187 737.94 359.597 738.95 357.237 739.83C354.457 740.83 352.057 741.74 352.057 741.74L351.717 740.98L349.647 736.08H347.897L343.897 731.62C343.897 731.62 343.157 691.38 341.337 692.27C340.736 692.604 340.203 693.048 339.767 693.58C331.747 702.44 318.907 747.12 318.907 747.12Z",
    fill: "#1F307A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.247 754.82C321.449 760.675 323.18 766.408 325.417 771.95C330.347 783.79 335.417 790.37 336.197 790.6C336.977 790.83 350.317 786.21 356.247 781.34C362.177 776.47 371.317 764.03 371.317 764.03L381.937 763.03C369.847 747.59 376.577 727.12 376.577 727.12L376.097 727.55L375.807 727.79L367.507 734.67V734.74L357.067 751.9L334.187 769L357.187 739.77C354.407 740.77 352.007 741.68 352.007 741.68L351.667 740.92L332.667 756.43L340.387 742.56L347.777 736.05L343.777 731.59C343.777 731.59 343.037 691.35 341.217 692.24C340.616 692.575 340.084 693.019 339.647 693.55L332.347 707.9L320.247 754.82Z",
    fill: "#0E1B5E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M310.648 658.121C310.648 658.121 310.058 663.261 310.098 663.691C310.138 664.121 311.098 664.981 311.098 664.981C311.098 664.981 312.218 683.551 303.448 691.661C303.448 691.661 287.358 675.871 285.108 668.341C282.858 660.811 283.168 648.531 283.168 648.531C283.168 648.531 291.168 634.671 292.718 628.431L310.648 658.121Z",
    fill: "url(#paint36_linear_1940_63057)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.647 670.961C310.647 670.961 306.967 677.671 303.647 677.851C297.907 678.161 288.367 670.511 288.367 670.511C288.367 670.511 295.787 687.361 304.477 693.511C308.441 686.651 310.566 678.884 310.647 670.961Z",
    fill: "#1F307A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.647 658.12L310.157 662.67C310.157 662.67 313.647 672.84 305.847 687.27C305.847 687.27 309.847 676.81 307.937 671.03C303.258 667.643 299.539 663.098 297.147 657.84C293.147 649.06 289.987 635.49 289.987 635.49L290.347 634.7L293.347 632.7L310.647 658.12Z",
    fill: "#8B009A"
  })))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M295.648 644.801C297.578 647.231 310.338 658.731 315.398 661.221C320.458 663.711 327.308 663.061 329.328 661.991C331.348 660.921 342.238 641.761 342.918 635.801C343.223 632.955 342.881 630.076 341.918 627.381C341.366 625.924 340.919 624.431 340.578 622.911C340.118 619.831 345.298 607.681 344.528 603.111C343.978 599.681 338.528 591.651 331.528 587.201L331.398 587.111C330.667 586.637 329.905 586.213 329.118 585.841C327.495 585.031 325.753 584.484 323.958 584.221C319.871 583.712 315.734 583.753 311.658 584.341H311.338C302.338 585.651 293.888 589.481 292.198 595.641C289.648 604.781 293.698 642.371 295.648 644.801Z",
    fill: "url(#paint37_linear_1940_63057)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M295.587 619.38C295.587 619.38 290.767 609.5 287.977 609.54C286.217 609.54 281.697 610.69 280.297 614.47C279.467 616.71 282.417 628.23 285.417 631.89C287.727 634.71 291.937 635.25 293.467 634.28C294.997 633.31 296.647 621.54 295.587 619.38Z",
    fill: "url(#paint38_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.058 600.46L296.998 620.6C296.998 620.6 298.928 615.71 299.668 615.12C300.408 614.53 306.068 614.07 306.068 614.07C306.068 614.07 317.198 622.71 321.928 623.07C326.658 623.43 328.928 604.9 328.928 604.9C332.729 604.358 336.605 604.916 340.098 606.51C340.098 606.51 333.838 618.9 333.278 621.9C332.718 624.9 338.048 628.31 341.878 627.43C341.327 625.974 340.879 624.48 340.538 622.96C340.078 619.88 345.258 607.73 344.488 603.16C343.938 599.73 338.488 591.7 331.488 587.25L331.358 587.16L329.078 585.89L323.388 582.7L311.648 584.34H311.328L301.198 587.61L294.058 600.46Z",
    fill: "url(#paint39_linear_1940_63057)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M290.648 611.41C290.648 611.41 295.108 616.41 297.008 620.6C296.836 617.787 296.893 614.964 297.178 612.16C297.668 608.16 302.108 604.84 303.508 602.97C304.908 601.1 305.508 594.88 305.588 593.12C305.668 591.36 307.838 590.96 307.838 590.96L304.838 588.61C305.168 588.3 311.108 589.97 311.108 589.97C311.123 589.949 311.144 589.932 311.168 589.92C311.168 589.92 311.228 589.92 311.258 589.84C312.108 589.16 316.768 585.46 318.778 585.56C318.778 585.56 330.368 595.07 334.298 596.9C337.212 598.171 340.221 599.211 343.298 600.01C343.864 601.226 344.284 602.505 344.548 603.82C344.548 604.76 341.808 616.4 341.808 616.4C341.808 616.4 353.708 605.97 353.498 596.4C349.226 595.07 345.181 593.101 341.498 590.56L341.338 590.4C340.266 589.657 339.263 588.82 338.338 587.9C337.928 587.49 337.498 587.08 337.098 586.65L337.018 586.58C331.698 581.24 327.348 576.58 321.738 577.03C315.668 577.53 308.088 583.12 300.838 586.57C293.588 590.02 292.628 589.57 289.838 591.77C289.568 592.007 289.37 592.316 289.268 592.66C287.758 596.9 290.648 611.41 290.648 611.41Z",
    fill: "#050E30"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.647 812.081C230.167 822.461 273.327 839.591 285.277 839.831C297.227 840.071 310.047 836.291 310.047 836.291C310.047 836.291 308.507 823.411 308.557 821.171C308.607 818.931 314.367 806.531 314.377 805.781C314.387 805.031 310.647 801.561 310.647 801.561C310.647 801.191 310.647 800.811 310.737 800.391C311.897 787.941 320.867 758.741 320.867 758.741C320.867 758.741 326.467 749.811 327.347 748.551C328.227 747.291 329.347 743.081 330.707 734.811C331.567 729.441 334.937 720.061 337.197 714.131C338.407 710.921 339.307 708.741 339.307 708.741C339.307 708.741 342.157 693.501 341.217 692.241C340.277 690.981 330.957 684.881 328.967 683.141C326.977 681.401 315.907 669.901 315.907 669.901L312.197 663.351L310.197 662.671C310.197 662.671 311.827 667.061 309.857 676.001C308.997 679.836 307.691 683.558 305.967 687.091L305.917 687.191C305.201 688.702 304.393 690.169 303.497 691.581C303.497 691.581 292.157 679.661 288.007 669.481C285.407 662.748 283.794 655.675 283.217 648.481L285.047 645.221H283.287C283.287 645.221 267.427 657.551 265.067 658.221C262.707 658.891 233.067 668.091 233.067 668.091C227.867 683.921 224.917 745.651 224.917 745.651C224.917 745.651 227.637 776.951 227.577 779.651C227.517 782.351 221.127 810.201 220.717 811.941L220.647 812.081Z",
    fill: "#0E1B5E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.058 668.141C233.058 668.141 247.998 675.401 250.258 681.981C252.518 688.561 247.858 722.091 247.858 722.091L248.468 727.091L222.068 747.901C222.068 747.901 206.548 755.171 200.488 755.211C194.428 755.251 181.788 750.051 181.028 747.811C180.268 745.571 195.358 717.181 213.368 701.121L233.058 668.141Z",
    fill: "#0E1B5E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M328.488 600.28C328.166 602.259 327.269 604.098 325.908 605.57C325.908 605.57 317.618 604.47 315.598 604.48C313.578 604.49 309.598 605.48 309.318 605.23C309.038 604.98 311.028 602.11 315.088 600.81C319.148 599.51 328.488 600.28 328.488 600.28Z",
    fill: "#050E30"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M343.468 609.189C343.468 609.189 342.838 608.66 342.588 608.67C341.188 608.67 338.198 611.219 337.838 611.059C337.478 610.899 339.838 605.269 344.558 603.819C344.558 603.819 344.878 607.069 343.468 609.189Z",
    fill: "#050E30"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.478 633.55C338.478 633.55 338.788 636.06 331.038 635.85C330.146 635.491 329.283 635.063 328.458 634.57C328.191 633.836 327.791 633.158 327.278 632.57C326.529 632.195 325.731 631.929 324.908 631.78C324.908 631.78 323.648 630.9 323.508 629.9C323.508 629.9 323.848 630.44 327.508 631.2C331.168 631.96 334.118 630.82 338.478 633.55Z",
    fill: "#D8646C"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    d: "M338.477 633.551C339.757 634.651 333.817 624.471 333.137 622.551C332.457 620.631 329.667 620.751 328.627 621.151C327.587 621.551 327.517 628.721 327.487 629.941C327.457 631.161 331.597 631.551 331.597 631.551C331.597 631.551 336.577 631.901 338.477 633.551Z",
    fill: "url(#paint40_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.93,
    d: "M311.157 589.9C311.757 589.41 316.687 585.43 318.767 585.54C318.767 585.54 330.357 595.05 334.287 596.88C337.201 598.151 340.21 599.191 343.287 599.99C343.853 601.206 344.272 602.485 344.537 603.8C344.537 604.74 341.797 616.38 341.797 616.38C341.797 616.38 353.697 605.95 353.487 596.38C353.487 596.38 341.607 596.78 333.487 592.38C325.367 587.98 319.367 581.73 319.057 582.05C318.747 582.37 311.917 589.16 311.157 589.9Z",
    fill: "url(#paint41_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.93,
    d: "M341.548 590.56C338.854 589.78 336.203 588.855 333.608 587.79C330.608 586.46 327.018 582.23 327.018 582.23C327.018 582.23 333.018 586.39 336.908 586.45L341.548 590.56Z",
    fill: "url(#paint42_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.93,
    d: "M290.648 611.411C290.648 611.411 295.108 616.411 297.008 620.601C296.836 617.787 296.893 614.965 297.178 612.161C297.668 608.161 302.108 604.841 303.508 602.971C304.908 601.101 305.508 594.881 305.588 593.121C305.668 591.361 307.838 590.961 307.838 590.961C306.69 590.867 305.538 590.844 304.388 590.891C303.578 591.011 301.828 595.521 298.758 597.141C296.148 598.511 290.848 594.021 289.368 592.671C287.758 596.901 290.648 611.411 290.648 611.411Z",
    fill: "url(#paint43_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.93,
    d: "M311.157 589.901C311.157 589.901 304.217 584.901 302.547 585.731C300.877 586.561 299.747 587.091 299.747 587.091L304.827 588.591L311.157 589.901Z",
    fill: "url(#paint44_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M353.507 596.41C346.622 596.619 339.781 595.251 333.507 592.41C323.507 587.74 319.077 582.08 319.077 582.08C319.077 582.08 330.837 587.08 341.547 590.55C345.213 593.099 349.246 595.075 353.507 596.41Z",
    fill: "#FFEDBB"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M304.378 590.901C304.378 590.901 299.838 592.821 296.288 592.671C292.738 592.521 291.348 590.671 291.348 590.671C291.348 590.671 289.638 591.611 289.348 592.671C289.348 592.671 293.918 597.431 296.738 597.531C299.558 597.631 304.378 590.901 304.378 590.901Z",
    fill: "#FFEDBB"
  })))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M336.907 586.45C336.907 586.45 328.907 586.12 321.787 577.04C321.787 577.04 328.527 576.02 336.907 586.45Z",
    fill: "#050E30"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M305.337 594.311C305.337 594.311 300.397 602.311 296.627 603.861C294.293 604.749 291.705 604.699 289.407 603.721L290.017 607.881C290.017 607.881 297.247 608.731 303.827 602.411C303.827 602.411 306.297 597.721 305.337 594.311Z",
    fill: "#C49786"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.718 624.23C294.718 624.23 288.718 614.02 285.358 613L282.298 614.77C282.298 614.77 282.298 625.22 285.118 629.08C285.118 629.08 283.188 623.23 283.788 618.39L285.548 615.64L288.078 617.43L285.908 621.58C285.908 621.58 286.098 627.77 291.588 628.41L290.888 625.85L292.258 623.29L294.718 624.23Z",
    fill: "url(#paint45_linear_1940_63057)"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.647 644.801L303.067 649.211L306.847 655.091C306.847 655.091 298.277 647.961 295.647 644.801Z",
    fill: "url(#paint46_linear_1940_63057)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.28
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.087 702.24L290.987 697.3C290.987 697.3 276.647 671.03 275.917 666.4C275.187 661.77 277.717 649.47 277.717 649.47L283.247 645.24L281.567 650.9C281.567 650.9 279.797 658.26 288.297 674.26C293.912 684.496 300.907 693.911 309.087 702.24Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.28
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.457 691.661L309.807 701.191C316.607 688.411 315.907 669.911 315.907 669.911L312.197 663.361L310.197 662.681C310.197 662.681 311.827 667.071 309.857 676.011C308.607 681.547 306.444 686.836 303.457 691.661Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.877 687.271L309.807 701.19L303.457 691.661L305.877 687.271Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.938 668.58C254.938 668.58 272.728 688.9 275.248 690.9C277.768 692.9 301.038 706.43 301.038 706.43C301.038 706.43 278.038 696.6 272.038 693.51C266.038 690.42 254.938 668.58 254.938 668.58Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.317 728.741C294.317 728.371 310.607 722.461 315.607 719.631C319.497 717.268 323.178 714.574 326.607 711.581L337.207 714.131C338.417 710.921 339.317 708.741 339.317 708.741C339.317 708.741 342.167 693.501 341.227 692.241C340.287 690.981 330.967 684.881 328.977 683.141C326.987 681.401 315.907 669.901 315.907 669.901L312.197 663.351L310.197 662.671C310.197 662.671 311.827 667.061 309.857 676.001C308.997 679.837 307.691 683.559 305.967 687.091C309.561 680.511 311.526 673.166 311.697 665.671L315.437 680.321L329.157 689.461L329.057 693.971C329.057 693.971 316.987 712.801 310.147 717.611C303.647 722.221 294.097 728.231 293.317 728.741Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.647 812.081C230.167 822.461 273.327 839.591 285.277 839.831C297.227 840.071 310.047 836.291 310.047 836.291C310.047 836.291 308.507 823.411 308.557 821.171C308.607 818.931 314.367 806.531 314.377 805.781C314.377 805.781 303.037 815.321 296.957 818.781C290.877 822.241 262.257 819.351 262.257 819.351C262.257 819.351 287.007 815.181 290.627 813.971C294.247 812.761 305.697 805.121 306.417 804.631C305.647 804.901 293.537 809.271 288.487 809.891C283.267 810.531 263.487 782.451 263.487 782.451C263.487 782.451 254.737 754.451 252.027 741.841C252.027 741.841 290.157 791.521 310.737 800.351C311.897 787.901 320.867 758.701 320.867 758.701C320.867 758.701 326.467 749.771 327.347 748.511C328.227 747.251 329.347 743.041 330.707 734.771C331.567 729.401 334.937 720.021 337.197 714.091L329.197 731.981L326.017 747.541C326.017 747.541 317.147 757.541 313.067 760.041C308.987 762.541 295.737 765.841 295.737 765.841C295.737 765.841 306.867 766.841 310.737 766.151L314.587 765.481L300.907 780.901C300.907 780.901 285.957 764.141 276.717 749.901C267.477 735.661 265.037 731.321 265.037 731.321C265.037 731.321 270.357 752.001 272.177 756.651C273.887 761.041 278.667 767.891 279.177 768.651C277.647 767.091 252.847 741.721 248.377 726.511L238.217 734.511L257.217 777.771L269.027 802.881C269.027 802.881 250.787 780.621 247.537 773.101C244.287 765.581 237.287 735.261 237.287 735.261L224.927 745.611C224.927 745.611 227.647 776.911 227.587 779.611C227.527 782.311 220.647 812.081 220.647 812.081Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.297 717.921L225.537 730.091L199.327 749.481L232.777 734.701L248.397 726.571L255.557 719.291L250.297 717.921Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.197 768.71L276.647 766.15C277.507 767.06 278.357 767.9 279.197 768.71Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.707 811.991L228.927 788.441L237.437 819.311L229.127 778.311L240.897 758.461L246.397 770.131L238.537 740.701L243.137 745.701L256.427 758.591L252.067 741.901L276.547 766.101C267.797 757.101 257.217 742.801 255.137 739.781C252.857 736.451 248.397 726.591 248.397 726.591L224.907 745.711C224.907 745.711 227.627 777.011 227.567 779.711C227.507 782.411 221.117 810.251 220.707 811.991Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.907 745.69L222.067 747.93L223.157 753.31L215.127 758.4L198.987 766.53L225.247 791.66L227.567 779.7L224.907 745.69Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.267 735.341L225.587 754.431L224.907 745.691L237.267 735.341Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.418 805.78C314.418 805.78 300.618 817.72 296.998 818.78C293.378 819.84 282.998 820.94 272.638 820.15C272.638 820.15 291.078 823.01 295.238 821.98C299.398 820.95 309.098 819.1 309.098 819.1L314.418 805.78Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.907 758.74C320.907 758.74 324.647 771.289 327.827 777.309L333.627 752.189L332.697 727.11L331.647 730.9L327.977 749.55L320.907 758.74Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.367 701.15L232.367 676.41L249.077 686.13L248.767 715.13C248.767 715.13 251.627 684.42 250.277 681.99C248.927 679.56 238.377 668.68 233.077 668.15L213.367 701.15Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.477 722.63C290.477 722.63 280.097 719.5 275.297 718.08C270.497 716.66 255.697 712.48 255.697 712.48C255.697 712.48 269.697 719.48 273.647 720.81C277.597 722.14 290.477 722.63 290.477 722.63Z",
    fill: "#8B009A"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.937 763.051C381.937 763.051 377.707 759.051 375.937 750.501C374.167 741.951 376.617 727.141 376.617 727.141C376.617 727.141 367.077 751.351 367.387 763.631L371.387 764.031L381.937 763.051Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.997 1089.35C193.667 1089.48 194.357 1089.62 195.077 1089.72L197.997 1083.48H218.567H230.697V1083.63V1083.8L232.017 1090.64C235.017 1090.45 236.887 1090.28 236.887 1090.28L237.017 1083.61L236.157 1078.91C236.157 1078.91 219.257 1080.91 210.157 1079.91C201.057 1078.91 197.467 1076.69 197.467 1076.69L199.127 1065.69C199.127 1065.69 218.127 1061.29 229.127 1065.69C211.897 1055.69 202.807 1058.46 202.807 1058.46L199.067 1062.05C194.497 1070.31 193.727 1082.72 193.727 1082.72L192.997 1089.35Z",
    fill: "#783E7A"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.877 1074.74L284.737 1081.74L329.017 1082.64L329.137 1076.55L371.217 1077.33L366.827 1074.1L329.207 1073.34L304.507 1065.89L319.847 1049.19L318.597 1048.09L317.517 1047.09C316.667 1047.41 304.887 1051.78 298.847 1056.27C292.597 1060.92 285.587 1071.41 285.587 1071.41L284.877 1074.74Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.337 743.511C380.107 738.221 379.108 732.493 379.417 726.761L377.167 728.831C377.167 728.831 374.727 741.601 377.067 749.831L382.337 743.511Z",
    fill: "#783E7A"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.838 727.81C409.248 729.3 403.838 738.51 403.488 739.07C404.398 738.07 410.248 728.16 413.718 724.56C417.948 720.19 424.358 718.67 424.358 718.67L424.648 715.9C419.148 712.61 412.888 714.26 411.028 715.5C409.168 716.74 404.878 726.01 404.878 726.01C403.088 728.13 399.638 727.18 399.638 727.18C399.638 727.18 401.188 718.7 403.948 713.56C405.585 710.489 407.767 707.74 410.388 705.45C401.278 709.45 395.678 728.38 395.678 728.38C398.058 728.6 406.398 726.63 406.398 726.63C406.398 726.63 410.438 726.27 409.838 727.81Z",
    fill: "url(#paint47_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.157 703.4L410.387 705.4C411.077 705.31 415.497 707.4 415.497 707.4C419.967 712.53 428.137 712.87 428.137 712.87C428.857 712.53 429.491 712.03 429.988 711.407C430.486 710.785 430.834 710.057 431.007 709.28L424.297 708.05C424.297 708.05 422.087 709.97 421.027 709.95C419.967 709.93 411.037 705.04 409.157 703.4Z",
    fill: "url(#paint48_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.598 828.651L222.938 843.391L221.758 838.541L235.208 825.011L240.598 828.651Z",
    fill: "#FFEDBB"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.258 681.98L263.698 687.22L254.938 668.58L250.648 664.9L233.098 668.16C239.972 671.114 245.906 675.893 250.258 681.98Z",
    fill: "#FFEDBB"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.787 727.61C283.787 727.61 288.937 712.61 288.427 711.77C287.917 710.93 286.297 709.42 285.087 709.63C283.877 709.84 280.897 727.12 280.897 727.12L283.787 727.61Z",
    fill: "#783E7A"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.698 718.43C275.698 718.43 265.018 719.3 261.008 715.08L261.718 716.69C265.141 718.983 269.213 720.109 273.328 719.9C274.17 719.5 274.965 719.007 275.698 718.43Z",
    fill: "#FFE7F1"
  })))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.478 722.63C290.478 722.63 276.188 721.39 273.648 720.81C271.108 720.23 255.698 712.48 255.698 712.48L254.378 720.48C254.378 720.48 266.098 726.38 269.588 727.2C273.078 728.02 288.128 728.62 288.128 728.62L290.478 722.63Z",
    fill: "#0E1B5E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.388 714.62L281.138 715.19L278.478 732.91L279.578 732.93L283.998 715.83L283.388 714.62Z",
    fill: "#783E7A"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.128 728.63L286.968 739.61L290.968 755.75L288.128 728.63Z",
    fill: "#774AA4"
  })))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.308 721.331L280.048 709.501L261.218 704.671H259.218L257.838 713.541C257.838 713.541 272.438 720.471 273.068 720.661C273.698 720.851 277.308 721.331 277.308 721.331Z",
    fill: "#3C8C6D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.878 714.53L275.778 714.46L258.348 709.99L257.798 713.5C257.798 713.5 271.208 720.2 273.028 720.62C274.848 721.04 277.308 721.33 277.308 721.33L278.878 714.53Z",
    fill: "#1D3652"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.647 720.811L275.887 709.421L280.047 709.501L277.307 721.331L273.647 720.811Z",
    fill: "#774AA4"
  })))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.897 642.651L338.557 644.161L337.667 644.531C337.667 644.531 334.477 647.531 332.847 647.351C328.527 646.831 323.437 643.741 321.127 641.951C318.817 640.161 316.947 635.901 316.947 635.901L318.687 635.721C318.522 635.873 318.395 636.061 318.316 636.272C318.238 636.482 318.211 636.708 318.237 636.931C318.488 637.712 318.956 638.406 319.587 638.931C321.507 640.931 326.287 643.611 331.487 644.501C336.687 645.391 337.777 643.701 337.777 643.701L337.897 642.651Z",
    fill: "#DD6668"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.968 635.9C319.968 635.9 315.378 635.9 312.808 637.68C313.99 635.999 315.724 634.786 317.708 634.25C318.574 634.627 319.345 635.191 319.968 635.9Z",
    fill: "url(#paint49_linear_1940_63057)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M331.707 649.26C329.762 648.552 327.752 648.032 325.707 647.71C325.707 647.71 326.627 651.65 327.887 651.94C329.147 652.23 331.707 649.26 331.707 649.26Z",
    fill: "url(#paint50_linear_1940_63057)"
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.647 636.49C295.647 636.49 298.457 642.21 301.327 647.43C302.703 650.056 304.281 652.57 306.047 654.95C309.227 658.66 316.477 663.04 318.137 663.49C319.797 663.94 327.687 664.34 329.417 663.11C330.587 662.28 336.147 652.11 339.887 644.92C341.747 641.4 343.137 638.62 343.377 638.09C344.057 636.47 342.957 631.48 342.957 631.48C342.153 631.567 341.339 631.488 340.566 631.247C339.794 631.006 339.079 630.609 338.467 630.08C336.894 628.563 335.565 626.813 334.527 624.89C334.527 624.89 330.847 623.16 329.447 623.22C328.586 623.374 327.756 623.664 326.987 624.08L326.697 624.21C325.585 624.807 324.424 625.309 323.227 625.71H323.167C322.037 625.86 306.437 622.71 306.437 622.71C306.437 622.71 303.557 625.71 300.717 629.16C298.755 631.404 297.054 633.863 295.647 636.49Z",
    fill: "url(#paint51_radial_1940_63057)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.407 623.24L329.267 630L321.897 630.5L304.067 625.9L320.527 627.96L323.117 625.74C325.162 624.782 327.262 623.947 329.407 623.24Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.647 636.491C295.647 636.491 302.887 651.261 306.047 654.971C309.207 658.681 316.477 663.06 318.137 663.51C319.797 663.96 327.687 664.36 329.417 663.13L316.107 657.76L313.307 655.76C313.307 655.76 301.987 645.691 299.207 639.211L310.867 648.211L320.867 652.151L313.547 646.231L306.197 634.51L307.987 634.051L319.677 636.26L329.307 632.331L314.497 633.211L301.627 628.771L300.757 629.271C298.788 631.478 297.073 633.9 295.647 636.491Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.517 639.07L336.447 632.99L339.407 640.03L339.837 644.94L342.517 639.07Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.277 647.431C302.653 650.056 304.231 652.57 305.997 654.951C309.177 658.661 316.427 663.041 318.087 663.491C319.747 663.941 327.637 664.341 329.367 663.111L316.057 657.741L301.277 647.431Z",
    fill: "#774AA4"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.307 632.95L332.347 639.89L332.327 656.09L334.307 632.95Z",
    fill: "#902377"
  })))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.567 623.66L293.567 615.66L292.567 614.29C292.567 614.29 297.567 616.35 306.327 622.75L305.567 623.66Z",
    fill: "url(#paint52_radial_1940_63057)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.608 636.49L292.328 633.69L291.088 634.09L296.948 639.18L295.608 636.49Z",
    fill: "url(#paint53_radial_1940_63057)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M306.688 608.24L324.397 611.7L324.367 613.13L314.848 613.59L306.688 608.24Z",
    fill: "url(#paint54_linear_1940_63057)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M335.218 617.44L341.498 617.56L340.978 619.56L337.188 621.03L335.218 617.44Z",
    fill: "url(#paint55_linear_1940_63057)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1940_63057",
    x1: 1323.1,
    y1: 1022.2,
    x2: 1321.97,
    y2: 993.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E81F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1370.11 893.573) rotate(177.709) scale(32.3158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1940_63057",
    x1: 1221.96,
    y1: 765.235,
    x2: 1224.37,
    y2: 751.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1940_63057",
    x1: 1389.2,
    y1: 768.951,
    x2: 1390.8,
    y2: 759.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1940_63057",
    x1: 1352.33,
    y1: 627.267,
    x2: 1350.75,
    y2: 587.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1940_63057",
    x1: 1329.04,
    y1: 622.73,
    x2: 1325.77,
    y2: 541.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1940_63057",
    x1: 1328.17,
    y1: 601.45,
    x2: 1325.77,
    y2: 541.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B060F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1940_63057",
    x1: 1233.46,
    y1: 783.514,
    x2: 1231.93,
    y2: 745.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1940_63057",
    x1: 1427.06,
    y1: 755.628,
    x2: 1402.33,
    y2: 756.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1940_63057",
    x1: 1322.34,
    y1: 599.851,
    x2: 1316.38,
    y2: 593.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF686A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC887E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1940_63057",
    x1: 1329.17,
    y1: 605.217,
    x2: 1324.75,
    y2: 600.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF686A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC887E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1940_63057",
    x1: 1350.35,
    y1: 621.517,
    x2: 1348.99,
    y2: 587.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D195AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#985E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1940_63057",
    x1: 1300.04,
    y1: 539.696,
    x2: 1300.03,
    y2: 539.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1C279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C97CA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1940_63057",
    x1: 1356.71,
    y1: 592.267,
    x2: 1361.31,
    y2: 565.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1940_63057",
    x1: 1381.49,
    y1: 921.433,
    x2: 1378,
    y2: 834.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B060F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1940_63057",
    x1: 1409.9,
    y1: 778.54,
    x2: 1408.9,
    y2: 753.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1940_63057",
    x1: 1354.17,
    y1: 884.755,
    x2: 1345.94,
    y2: 678.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B959F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C59B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1940_63057",
    x1: 1384.02,
    y1: 1021.23,
    x2: 1382.8,
    y2: 990.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E81F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1940_63057",
    x1: 1410.63,
    y1: 778.35,
    x2: 1413.18,
    y2: 763.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1940_63057",
    x1: 1402.59,
    y1: 777.901,
    x2: 1405.62,
    y2: 760.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1940_63057",
    x1: 1395.93,
    y1: 774.872,
    x2: 1398.53,
    y2: 759.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1940_63057",
    x1: 1305.35,
    y1: 606.02,
    x2: 1352.11,
    y2: 604.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1940_63057",
    x1: 1343.6,
    y1: 590.427,
    x2: 1318.26,
    y2: 591.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B488B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E81F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1940_63057",
    x1: 1352.23,
    y1: 607.079,
    x2: 1318.95,
    y2: 608.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BA9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E77B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1940_63057",
    x1: 1311.43,
    y1: 602.411,
    x2: 1306.11,
    y2: 602.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BA9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E77B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1940_63057",
    x1: 1315.56,
    y1: 606.252,
    x2: 1313.73,
    y2: 606.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B488B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E81F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1344.74 572.316) rotate(-2.15002) scale(12.012 11.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C5E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1353.15 590.924) rotate(-2.14996) scale(7.4985 7.20994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1940_63057",
    x1: 1338.74,
    y1: 607.649,
    x2: 1316.15,
    y2: 608.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BA9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E77B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1940_63057",
    x1: 1331.9,
    y1: 579.116,
    x2: 1331.62,
    y2: 572.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#59936A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1940_63057",
    x1: 1307.98,
    y1: 583.417,
    x2: 1307.82,
    y2: 579.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#59936A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1940_63057",
    x1: 1211.69,
    y1: 927.354,
    x2: 1292.83,
    y2: 920.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#051535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1940_63057",
    x1: 1277,
    y1: 927.824,
    x2: 1343,
    y2: 927.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#091335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1940_63057",
    x1: 1155.09,
    y1: 817.654,
    x2: 1428.16,
    y2: 793.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1940_63057",
    x1: 426.077,
    y1: 718.997,
    x2: 394.057,
    y2: 718.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B8A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1D3653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1940_63057",
    x1: 430.715,
    y1: 723.132,
    x2: 371.435,
    y2: 721.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1940_63057",
    x1: 296.438,
    y1: 691.836,
    x2: 297.698,
    y2: 628.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1940_63057",
    x1: 325.783,
    y1: 663.161,
    x2: 313.494,
    y2: 584.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1940_63057",
    x1: 290.496,
    y1: 635.254,
    x2: 286.569,
    y2: 610.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1940_63057",
    x1: 318.755,
    y1: 627.426,
    x2: 319.646,
    y2: 582.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B045BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1940_63057",
    x1: 332.981,
    y1: 633.834,
    x2: 333.233,
    y2: 621.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B045BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1940_63057",
    x1: 353.396,
    y1: 599.997,
    x2: 310.916,
    y2: 599.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1940_63057",
    x1: 341.555,
    y1: 586.835,
    x2: 326.875,
    y2: 586.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1940_63057",
    x1: 297.736,
    y1: 620.934,
    x2: 298.334,
    y2: 591.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1940_63057",
    x1: 305.354,
    y1: 590.104,
    x2: 305.436,
    y2: 586.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BE6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E81F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1940_63057",
    x1: 288.252,
    y1: 629.457,
    x2: 288.573,
    y2: 613.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C760C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1940_63057",
    x1: 306.88,
    y1: 650.378,
    x2: 295.47,
    y2: 650.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1D3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1940_63057",
    x1: 424.488,
    y1: 722.918,
    x2: 395.778,
    y2: 722.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C245BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1940_63057",
    x1: 431.004,
    y1: 708.692,
    x2: 409.034,
    y2: 708.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C245BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1940_63057",
    x1: 323.58,
    y1: 636.685,
    x2: 316.769,
    y2: 635.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B060F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1940_63057",
    x1: 331.984,
    y1: 652.119,
    x2: 332.456,
    y2: 648.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B060F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.544 630.946) rotate(-178.949) scale(37.3824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C5E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.993 619.258) rotate(-178.949) scale(9.46277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C5E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1940_63057",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.267 638.226) rotate(-178.949) scale(4.81859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1940_63057",
    x1: 315.402,
    y1: 613.914,
    x2: 315.506,
    y2: 608.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#59936A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1940_63057",
    x1: 338.224,
    y1: 621.352,
    x2: 338.295,
    y2: 617.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#59936A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_63057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1127,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.873151a2b5edc2b187606f30a23b3e1c.svg";
export { ForwardRef as ReactComponent };